import getConfig from 'next/config';

export const getLegoUrl = (): string => {
  const { publicRuntimeConfig, serverRuntimeConfig } = getConfig();

  if (serverRuntimeConfig.legoUrl) {
    return serverRuntimeConfig.legoUrl;
  }

  return publicRuntimeConfig.legoUrl;
};
